// extracted by mini-css-extract-plugin
module.exports = {"root":"TextPlaceholder_root__25XAj"};